"use client";

import type { ReactNode } from "react";
import {
  ColumnLayoutRatio,
  iColumnBlockData,
  iHolidayQuoteContentBlocks,
} from "@/@sdk/holiday-quotes-x/holiday-quotes-x-model";
import { cn } from "@/lib/utils";

const LAYOUT_CLASS: Record<ColumnLayoutRatio, string> = {
  "35_65": "md:grid-cols-[7fr_13fr]",
  "50_50": "md:grid-cols-2",
  "65_35": "md:grid-cols-[13fr_7fr]",
};

interface ColumnSectionProps {
  columnData?: iColumnBlockData;
  renderBlock: (block: iHolidayQuoteContentBlocks) => ReactNode;
}

export function ColumnSection({
  columnData,
  renderBlock,
}: ColumnSectionProps) {
  const layout = columnData?.layout || "50_50";
  const left = columnData?.left ?? [];
  const right = columnData?.right ?? [];

  return (
    <section>
      <div
        className={cn(
          "grid grid-cols-1 gap-4 md:gap-6",
          LAYOUT_CLASS[layout]
        )}
      >
        <div className="min-w-0 space-y-4">
          {left.map((block) => (
            <div key={block.id} id={`content-${block.id}`}>
              {renderBlock(block)}
            </div>
          ))}
        </div>
        <div className="min-w-0 space-y-4">
          {right.map((block) => (
            <div key={block.id} id={`content-${block.id}`}>
              {renderBlock(block)}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function getColumnLayoutLabel(layout: ColumnLayoutRatio): string {
  switch (layout) {
    case "35_65":
      return "35% / 65%";
    case "65_35":
      return "65% / 35%";
    default:
      return "50% / 50%";
  }
}
